<div class="unit-accesspoint">
  <div class="header mt-1">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor pb-5"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <div class="text-center">
        <h4 class="mb-0">
          <span> {{ formGroupUserDetail?.value?.firstName }} </span>

          <span> {{ formGroupUserDetail?.value?.lastName }} </span>
        </h4>
        <h1 class="modal-title mtm-10 mb-0">
          {{ 'USER_ADD_USER' | translate }}
        </h1>
      </div>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>

  <div class="scroll-container">
    <div class="listing unit-list unit-list-height">
      <div class="overflow-y">
        <ng-container
          *ngFor="let unit of mergedUnitsAccessPoint; let j = index"
        >
          <h2
            class="selected-floorName title bold"
            *ngIf="checkIfNew(unit?.buildingName, j)"
          >
            <app-with-tooltip [showHelpCursor]="true">
              {{ unit?.buildingName.toUpperCase() }}
            </app-with-tooltip>
          </h2>

          <ng-container *ngIf="unit?.unitName">
            <div class="form-group rounded-top form-container">
              <div
                class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
              >
                <div class="d-flex list-box full align-items-center">
                  <span>
                    <img
                      src="/assets/svg/ico-default-home-circle.svg"
                      alt="ico-building-with-black-circle"
                      class="left-icon"
                    />
                  </span>
                  <span class="title bold">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ unit?.unitName }}
                    </app-with-tooltip>
                  </span>

                  <span class="selected-value-container checked-spacer">
                    <span class="selected-value time-right"> </span>
                    <span class="btn-not-text"> </span>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>

          <ng-container *ngIf="unit?.accessPointName">
            <div class="form-group rounded-top form-container">
              <div
                class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
              >
                <div class="d-flex list-box full align-items-center">
                  <span>
                    <img
                      src="/assets/images/accesspoint-icon.png"
                      alt="ico-building-with-black-circle"
                      class="left-icon"
                    />
                  </span>
                  <span class="title bold">
                    <app-with-tooltip [showHelpCursor]="true">
                      {{ unit?.accessPointName }}
                    </app-with-tooltip>
                  </span>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="userGroup?.length > 0">
          <h2 class="selected-floorName">
            <app-with-tooltip [showHelpCursor]="true">
              {{ 'GROUPS' | translate }}
            </app-with-tooltip>
          </h2>
        </ng-container>

        <ng-container *ngFor="let group of userGroup; let j = index">
          <div class="form-group rounded-top form-container">
            <div
              class="w-100 building-list-container primary-input bottom-zero padding-top-balance middle"
            >
              <div class="d-flex list-box full align-items-center">
                <span>
                  <img
                    src="/assets/svg/ico-circle-group.svg"
                    alt="ico-building-with-black-circle"
                    class="left-icon"
                  />
                </span>
                <span class="title bold">
                  <app-with-tooltip [showHelpCursor]="true">
                    {{ group?.userGroupName }}
                  </app-with-tooltip>
                </span>

                <span class="selected-value-container checked-spacer">
                  <span class="selected-value time-right"> </span>
                  <span class="btn-not-text"> </span>
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
